(function () {
  const timers = new WeakMap();

  function start(bar) {
    const slides = bar.querySelectorAll(".sst-announcement-bar__slide");
    if (slides.length < 2) return;

    clearInterval(timers.get(bar));

    const speed = (parseFloat(bar.dataset.speed) || 4) * 1000;
    let index = Array.from(slides).findIndex((slide) =>
      slide.classList.contains("is-active"),
    );
    if (index < 0) index = 0;

    const timer = setInterval(function () {
      slides[index].classList.remove("is-active");
      index = (index + 1) % slides.length;
      slides[index].classList.add("is-active");
    }, speed);

    timers.set(bar, timer);
  }

  function init() {
    document.querySelectorAll("[data-sst-announcement-bar]").forEach(start);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
})();
